import React from "react";
import { CustomeDialog as DialogSlide } from "../../../shared";
import { useImmer } from "use-immer";
import { Button, Stack } from "@mui/material";
import { DashBoardDateRangePicker } from "../..";
import { useNavigate } from "react-router-dom";
import { convertDate } from "../../../utils";

const defaultDateObject = {
  value: [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ],
  showDate: [],
};

export const ManageOnDemandStatement = ({ open, handleClose }) => {
  const { onChangeDate, state, handleFormSubmit } = useManageOnDemandStatement({
    open,
  });

  return (
    <DialogSlide
      open={open}
      PaperProps={{
        sx: { minWidth: "372px", p: "16px" },
      }}
      title="Generate On Demand Statement"
      content={
        <Stack
          component="form"
          gap={3}
          py={1}
          justifyContent="space-between"
          onSubmit={handleFormSubmit}
        >
          <Stack pt="16px">
            <DashBoardDateRangePicker
              onChangeDate={onChangeDate}
              isList={true}
              range={state.date.value}
              showRange={state.date.showDate}
              className="dashBoard-calender"
              label="Select date range"
              popperPicker={false}
            />
          </Stack>
          <Stack flexDirection="row" gap="16px" justifyContent="end">
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              type="submit"
              variant="contained"
              disabled={state.date.showDate.length === 0}
            >
              Continue
            </Button>
          </Stack>
        </Stack>
      }
    />
  );
};

const useManageOnDemandStatement = ({ open }) => {
  const [state, setState] = useImmer({
    date: defaultDateObject,
  });

  const navigate = useNavigate();
  const onChangeDate = async (event) => {
    setState((draft) => {
      draft.date.value = event;
      draft.date.showDate = event;
    });
  };

  const resetDateRange = () => {
    setState((draft) => {
      draft.date = defaultDateObject;
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    navigate(
      `statement?start_date=${convertDate({
        date: state.date.value[0].startDate,
      })}&end_date=${convertDate({
        date: state.date.value[0].endDate,
      })}`
    );
  };

  React.useEffect(() => {
    return () => {
      resetDateRange();
    };
  }, [open]);

  return {
    state,
    onChangeDate,
    handleFormSubmit,
  };
};
